<template>
  <div class="sentence">
    <h1>
      A Catalyst at the Intersection of
      <span :class="['changing-word', { 'fade-out': isAnimating }]">{{
        currentWord
      }}</span>
    </h1>
  </div>
</template>

<script>
export default {
  name: "WordAnimator",
  data() {
    return {
      words: ["Creativity", "User Experience", "Strategy", "Business Impact"],
      currentIndex: 0,
      isAnimating: false,
      intervalId: null,
    };
  },
  computed: {
    currentWord() {
      return this.words[this.currentIndex];
    },
  },
  methods: {
    changeWord() {
      this.isAnimating = true;

      setTimeout(() => {
        this.currentIndex = (this.currentIndex + 1) % this.words.length;
        this.isAnimating = false;
      }, 500);
    },
    startAnimation() {
      // Clear any existing interval first
      this.stopAnimation();
      this.intervalId = setInterval(this.changeWord, 2000);
    },
    stopAnimation() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
  },
  mounted() {
    this.startAnimation();
  },
  beforeDestroy() {
    this.stopAnimation();
  },
};
</script>

<style scoped>
.sentence {
  /* font-family: Arial, sans-serif; */
  /* font-size: 24px; */
  /* text-align: center; */
  /* padding: 20px; */
}

.changing-word {
  display: inline-block;
  transition: opacity 0.5s ease-in-out;
  /* color: #ffffff; */
  font-weight: bold;

  font-size: 6rem;
  min-width: 60px; /* Prevents layout shift during word changes */
}

.fade-out {
  opacity: 0;
}
</style>
